import * as React from 'react';
import { Inline, Tag } from 'braid-design-system';

interface Props {
  skills: string[];
}
const Skills = ({ skills }: Props) => {
  const elements = skills.map((skill) => <Tag key={skill}>{skill}</Tag>);
  return <Inline space="small">{elements}</Inline>;
};

export default Skills;
